
export class CeSelection {
    private _id: string;
    private _from: string;
    private _to: string;

    constructor() {
        this.init();
    }

    init(): void {
        this._id = '';
        this._from = '';
        this._to = '';
    }

    /* Exact identifier */
    set id(value: string) {
        this.init();
        if (value) {
            this._id = value;
        }
    }

    get id(): string {
        return this._id;
    }

    /* Content anchor begin */
    set from(value: string) {
        this._id = '';
        if (value) {
            this._from = value;
        } else {
            this._from = '';
        }
    }

    get from(): string {
        return this._from;
    }

    /* Content anchor end */
    set to(value: string) {
        this._id = '';
        if (value) {
            this._to = value;
        } else {
            this._to = '';
        }
    }

    get to(): string {
        return this._to;
    }

    getFromAsNum(): number {
        return parseInt(this._from.substring(this._from.lastIndexOf('_') + 1), 10);
    }

    getToAsNum(): number {
        return parseInt(this._to.substring(this._to.lastIndexOf('_') + 1), 10);
    }

    isValid(): boolean {
        return  !!this._id || (!!this._from && !!this._to);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ce-selection.ts